module.exports = __webpack_public_path__ + "img/401k.24439931.jpeg";